import React from 'react';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import { GRID_FILTER_KEYS } from '../../../../Base/Components/GridFilter/gridFilterKeys';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';
import useFilters from '../../../../Base/Hooks/useFilters';
import { useAppContext } from '../../../../../Services/AppContext';

export interface WorkplaceWorkersFilterValues {
	fulltext?: string;
	workplaceIds?: string[];
	roleIds?: string[];
}

interface Props {
	onFilter: (values: WorkplaceWorkersFilterValues) => void;
	showWorkplacesFilter: boolean;
}

const WorkplaceWorkersFilter: React.FC<Props> = ({
	onFilter,
	showWorkplacesFilter,
}) => {
	const { workplaceId } = useAppContext();
	const { handleMultiSelectValue, checkEmptyString } = useFilters();
	const onFilterData = (values: any) => {
		const filter: WorkplaceWorkersFilterValues = {
			fulltext: checkEmptyString(values?.fulltext),
			workplaceIds: showWorkplacesFilter
				? handleMultiSelectValue(values?.workplaceIds)
				: [workplaceId],
			roleIds: handleMultiSelectValue(values?.roleIds),
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.MANAGER_WORKPLACE_WORKERS}>
			<GridFilterItem
				type={
					showWorkplacesFilter
						? GridFilterItemType.ROLES
						: GridFilterItemType.ROLES_WITHOUT_ADMIN
				}
				width={280}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.FULLTEXT}
				width={400}
				customLabel='component.workplaceAndWorkers.workerSurname'
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.WORKPLACES}
				width={350}
				enableAutocomplete
				visible={showWorkplacesFilter}
			/>
		</GridFilter>
	);
};

export default WorkplaceWorkersFilter;
